import { render, staticRenderFns } from "./InvL.vue?vue&type=template&id=0e22518b"
import script from "./InvL.vue?vue&type=script&lang=js"
export * from "./InvL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports